import { createContext } from 'react';
import { SideBarContextType } from './types';

export const SideBarContext = createContext<SideBarContextType | undefined>(undefined);
